import { Link } from "@tanstack/react-router";
import { Compass } from "lucide-react";
import { EmptyState } from "@/components/empty-states/empty-state";
import { Button } from "@/components/ui/button";

export function NotFound({
  title = "Page not found",
  description = "This page doesn't exist or you don't have access to it.",
}: {
  title?: string;
  description?: string;
}) {
  return (
    <div className="flex flex-1 items-center justify-center p-10">
      <EmptyState
        icon={Compass}
        title={title}
        description={description}
        action={
          <Button variant="outline" size="sm" nativeButton={false} render={<Link to="/" />}>
            Go to Overview
          </Button>
        }
      />
    </div>
  );
}
